import { Injectable } from '@angular/core';
import { webSocket } from 'rxjs/webSocket';
import { Observable, Subject } from 'rxjs';
import { delay, retryWhen, tap } from 'rxjs/operators';

@Injectable()
export class SocketClientService {
     private url: string;
     private port: string;
     private host: string;
     private path: string;
     // http://reactivex.io/rxjs/class/es6/Observable.js~Observable.html#static-method-webSocket
     socket$: Subject<{ action: string; body: any }> = new Subject();
     private _unsubscribeSocketSrv;

     constructor() {
          const DEFAULT_HOST = window.location.hostname,
               DEFAULT_PORT = window.location.port;
          let conf =
               (window.app && window.app.conf && window.app.conf.socket) || {};

          this.host = window.app.conf.socket.host || DEFAULT_HOST;
          this.port = window.app.conf.socket.port || DEFAULT_PORT;
          this.path = window.app.conf.socket.path || '';
          this.setUrl();
          this._unsubscribeSocketSrv = this.createSocket();
     }

     setUrl() {
          this.url =
               'ws://' +
               this.host +
               (this.port && this.port !== '80' ? ':' + this.port : '') +
               this.path;
     }

     close() {
          if (this._unsubscribeSocketSrv) {
               this._unsubscribeSocketSrv.unsubscribe();
          }
     }

     private createSocket() {
          /*
      Create an observable that will emit our code
    */
          let ob = Observable.create(() => {
               let socket = webSocket({
                    url: this.url,
                    closingObserver: {
                         closed: false,
                         complete: () => {
                              console.log('SOCKET_DONE');
                         },
                         error: (error) => {
                              console.log('SOCKET_ERROR', error);
                         },
                         next: (value) => {
                              console.log('SOCKET_NEXT', value);
                         },
                    },
               });
               socket
                    .pipe(
                         retryWhen((errors) =>
                              errors.pipe(
                                   // log error message
                                   tap((val) => console.log('val', val)),
                                   // restart in 5 seconds
                                   delay(5000)
                              )
                         )
                    )
                    .subscribe(
                         (data: any) => {
                              this.socket$.next(data);
                         },
                         (error) => {
                              console.log('socket_error', error);
                         }
                    );
               return () => {
                    socket.unsubscribe();
               };
          });

          return ob.subscribe(
               () => {
                    console.log('ob.subscribe start');
               },
               (error) => {
                    console.log('ob.subscribe error', error);
               }
          );
     }
}
